<script setup>
defineProps({
  value: {
    type: [Number, String],
    default: 0,
  },
  valueClass: {
    type: [String, Array, Object],
    default: '',
  },
  emptyClass: {
    type: [String, Array, Object],
    default: 'text-slate-300 dark:text-slate-700',
  },
  emptyValue: {
    type: String,
    default: '---',
  },
  showZero: {
    type: Boolean,
    default: false,
  },
});

const hasValue = (value, showZero) => {
  const numericValue = Number(value);
  return showZero ? numericValue >= 0 : numericValue > 0;
};
</script>

<template>
  <Transition name="metric-value" mode="out-in">
    <span
      :key="value"
      class="inline-block"
      :class="hasValue(value, showZero) ? valueClass : emptyClass"
    >
      {{ hasValue(value, showZero) ? value : emptyValue }}
    </span>
  </Transition>
</template>

<style lang="scss" scoped>
.metric-value-enter-active,
.metric-value-leave-active {
  @apply transition-all duration-200 ease-out;
}

.metric-value-enter-from {
  @apply opacity-0 translate-y-1 scale-95;
}

.metric-value-leave-to {
  @apply opacity-0 -translate-y-1 scale-95;
}
</style>
